export const useRateLimiterStore = defineStore('ratelimiter', () => {
  const limit = ref(10)
  const remaining = ref(10)
  const retryAt = ref()
  const secondsLeft = ref()
  const limited = computed(() => {
    return retryAt.value && retryAt.value > Date.now() / 1000
  })
  return { limit, limited, remaining, retryAt, secondsLeft }
})
